import { useEffect, useState } from 'react';

import useGetWindowSize from '../../../../hooks/useGetWindowSize';

const useIsReelOverflowActive = (reelRef: React.MutableRefObject<HTMLUListElement | null>) => {
    const [isOverflowActive, setIsOverflowActive] = useState(false);

    const windowSize = useGetWindowSize();

    useEffect(() => {
        if (!reelRef.current) {
            return;
        }

        const computedStyles = window.getComputedStyle(reelRef.current);
        const paddingInlineEnd = parseFloat(computedStyles.paddingInlineEnd);

        setIsOverflowActive((reelRef.current.scrollWidth - paddingInlineEnd) > reelRef.current.clientWidth);
    }, [windowSize, reelRef]);

    return isOverflowActive;
};

export default useIsReelOverflowActive;
